import {
    DELETE_PRODUCT_FAILURE,
    DELETE_PRODUCT_REQUEST,
    DELETE_PRODUCT_SUCCESS,
    RESET_DELETE_PRODUCT_STATE
} from "../actions/delete-product-actions";


const initialState = {
    isDeleted: false,
    isLoading: false,
    error: null,
};

export default function deleteProductReducer(state = initialState, action) {
    switch (action.type) {
        case DELETE_PRODUCT_REQUEST:
            return { ...state, isLoading: true, error: null, isDeleted: false };
        case DELETE_PRODUCT_SUCCESS:
            return { ...state, isLoading: false, isDeleted: true };
        case DELETE_PRODUCT_FAILURE:
            return { ...state, isLoading: false, error: action.payload, isDeleted: false };
        case RESET_DELETE_PRODUCT_STATE:
            return initialState;
        default:
            return state;
    }
}